module.exports = __webpack_public_path__ + "img/custom-item1-3.c404d46.png";